"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var BlInput_1 = __importDefault(require("../../../FormComponents/BlInput"));
var Validation_1 = __importDefault(require("../../../Validation"));
var OldNewPassword = function (props) {
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: "flex-column" },
        react_1.default.createElement(Validation_1.default, { name: "oldPassword", formikProps: props },
            react_1.default.createElement(BlInput_1.default, { placeholder: t('Account.Settings.CurrentPassword'), type: "password", onChange: props.handleChange, value: props.values.oldPassword })),
        react_1.default.createElement(Validation_1.default, { name: "password", formikProps: props },
            react_1.default.createElement(BlInput_1.default, { type: "password", placeholder: t('Account.Settings.NewPassword'), onChange: props.handleChange, value: props.values.password })),
        react_1.default.createElement(Validation_1.default, { name: "passwordConfirmation", formikProps: props },
            react_1.default.createElement(BlInput_1.default, { type: "password", placeholder: t('Account.Settings.ConfirmPassword'), onChange: props.handleChange, value: props.values.passwordConfirmation }))));
};
exports.default = OldNewPassword;
